import { ChangeDetectionStrategy, Component, ElementRef, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'mcrai-panel-actions',
  template: `<ng-content></ng-content>
`,
  styles: [`.mcrai-panel__actions{display:flex;justify-content:flex-end;align-items:center;padding:0 20px;height:65px;margin-top:-1px}`],
  preserveWhitespaces: false,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ActionsComponent implements OnInit {
  readonly PANEL_ACTIONS_CLASS = 'mcrai-panel__actions';

  constructor(
    private _renderer: Renderer2,
    private _elRef: ElementRef
  ) { }

  ngOnInit() {
    this._renderer
      .addClass(this._elRef.nativeElement, this.PANEL_ACTIONS_CLASS);
  }
}
